import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["className", "label", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classnames from 'classnames';
import React from 'react';
import styles from './tooltip.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Tooltip = function Tooltip(_ref) {
  var _classnames, _classnames2;

  var id = _ref.id,
      className = _ref.className,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      top = _ref.top,
      left = _ref.left,
      right = _ref.right,
      bottom = _ref.bottom,
      bottomRight = _ref.bottomRight,
      topRight = _ref.topRight,
      _ref$nozzle = _ref.nozzle,
      nozzle = _ref$nozzle === void 0 ? true : _ref$nozzle;
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: classnames(className, styles.tooltip, (_classnames = {}, _defineProperty(_classnames, styles.dark, theme === 'dark'), _defineProperty(_classnames, styles.light, theme === 'light'), _classnames)),
    children: [title && /*#__PURE__*/_jsx("p", {
      className: styles.title,
      children: title
    }), description && /*#__PURE__*/_jsx("p", {
      className: styles.description,
      children: description
    }), children || null, /*#__PURE__*/_jsxs("svg", {
      className: classnames(styles.tip, (_classnames2 = {}, _defineProperty(_classnames2, styles.dark, theme === 'dark'), _defineProperty(_classnames2, styles.top, top || !left && !right && !bottom && !bottomRight && !topRight), _defineProperty(_classnames2, styles.left, left), _defineProperty(_classnames2, styles.right, right), _defineProperty(_classnames2, styles.bottom, bottom), _defineProperty(_classnames2, styles.bottomRight, bottomRight), _defineProperty(_classnames2, styles.topRight, topRight), _classnames2)),
      xmlns: "http://www.w3.org/2000/svg",
      width: nozzle ? '25' : '0',
      height: nozzle ? '8' : '0',
      fill: "none",
      children: [/*#__PURE__*/_jsx("g", {
        children: /*#__PURE__*/_jsx("path", {
          d: "M10.592 6.928l.051.117c.493 1.127 2.092 1.127 2.585 0A11.76 11.76 0 0 1 24.001 0H-.001c4.594 0 8.752 2.719 10.593 6.928z",
          fill: theme === 'dark' ? '#111111' : '#fff'
        })
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsxs("filter", {
          x: "-12.001",
          y: "-12",
          width: "48.002",
          height: "31.891",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [/*#__PURE__*/_jsx("feFlood", {
            floodOpacity: "0"
          }), /*#__PURE__*/_jsx("feGaussianBlur", {
            "in": "BackgroundImage",
            stdDeviation: "6"
          }), /*#__PURE__*/_jsx("feComposite", {
            in2: "SourceAlpha",
            operator: "in"
          }), /*#__PURE__*/_jsx("feBlend", {
            "in": "SourceGraphic"
          })]
        })
      })]
    })]
  });
};
export var TooltipWrapper = function TooltipWrapper(_ref2) {
  var className = _ref2.className,
      label = _ref2.label,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.wrapper, className),
    children: [children, /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      className: classnames(styles.tooltip)
    }, props), {}, {
      children: label && /*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: label
      })
    }))]
  });
};